import ContentInput from './ContentInput';

const content = {
  id: 'content',
  name: 'Content',
  Input: ContentInput,
  setInitialContent: content => {
    return {
      text: content.text || '',
      button: content.button || '',
      title: content.title || '',
      markdown: content.markdown || ''
    };
  },
  valid: content => {
    return (
      content.text.length > 0 &&
      content.button.length > 0 &&
      content.title.length > 0 &&
      content.markdown.length > 0
    );
  },
  snippet: `{
    "type": "content",
    "content": {
      "text": "",
      "button": "",
      "title": "",
      "markdown": ""
    }
}`
};

export default content;
